import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AsyncPipe, CommonModule, DatePipe } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { InternalRoutingModule } from "./internal-routing.module";
import { InternalComponent} from "../internal/internal.component";
import { DateagoPipe } from "./../pipe/dateago.pipe";
import { LimitToPipe } from "./../pipe/limit-to.pipe";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InterceptorService } from "./../services/interceptor.service";
import { DataSharingService } from "./../services/data.share.service";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NumberOnlyDirective } from "../directive/number-only.directive";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxMaskModule, IConfig } from "ngx-mask";

import { CapitalizeFirstDirective } from "../directive/capitalize-first.directive";
import { CommonComponent } from "../shared/common"
import { UploadDocumentComponent } from "./upload-document/upload-document.component";
import { CompleteProfileComponent } from "./complete-profile/complete-profile.component";
import { ResumeBuildComponent } from "./resume-build/resume-build.component";
import { SidebarComponent } from "../common/sidebar/sidebar.component";
import { SkillsComponent } from "./skills/skills.component";
import { EducationComponent } from "./education/education.component";
import { AddEduComponent } from "./education/add-edu/add-edu.component";
import { WorkExpComponent } from "./work-exp/work-exp.component";
import { AddWorkComponent } from "./work-exp/add-work/add-work.component";
import { VolunteerComponent } from "./volunteer/volunteer.component";
import { AddVolComponent } from "./volunteer/add-vol/add-vol.component";
import { ProjectsComponent } from "./projects/projects.component";
import { AddProjectsComponent } from "./projects/add-projects/add-projects.component";
import { AwardsComponent } from "./awards/awards.component";
import { AddAwardComponent } from "./awards/add-award/add-award.component";
import { LiceneseComponent } from "./licenese/licenese.component";
import { AddLiceneseComponent } from "./licenese/add-licenese/add-licenese.component";
import { LanguageComponent } from "./language/language.component";
import { AddLanguageComponent } from "./language/add-language/add-language.component";
import { JobPreferencesComponent } from "./job-preferences/job-preferences.component";
import { ResumeOverviewComponent } from "./resume-overview/resume-overview.component";
import { PhoneMaskDirective } from "../directive/phone-mask.directive";

import { NgOtpInputModule } from "ng-otp-input";
import { LightboxModule } from "ngx-lightbox";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { CommonImageUploadComponent } from "../common-image-upload/common-image-upload.component";
@NgModule({
  declarations: [
    SidebarComponent,
    UploadDocumentComponent,
    CompleteProfileComponent,
    CommonComponent,
    ResumeBuildComponent, 
    SkillsComponent,
    EducationComponent,
    AddEduComponent,
    WorkExpComponent,
    AddWorkComponent,
    VolunteerComponent,
    AddVolComponent,
    ProjectsComponent,
    AddProjectsComponent,
    AwardsComponent,
    AddAwardComponent,
    LiceneseComponent,
    AddLiceneseComponent,
    LanguageComponent,
    AddLanguageComponent,
    JobPreferencesComponent,
    ResumeOverviewComponent,
    CommonImageUploadComponent
  ],
  imports: [
    RouterModule,
    InternalRoutingModule,
    FormsModule,
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxSpinnerModule,
    ImageCropperModule,
    NgxMaskModule.forRoot(),
    NgOtpInputModule,
    NgMultiSelectDropDownModule.forRoot(),
    GooglePlaceModule
  ],
  providers: [
    AsyncPipe,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    NgxSpinnerModule,
    DataSharingService,
  ],
  bootstrap: []
})
export class InternalModule {}
